// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__thY2K","layout-body":"style_layout-body__Ww_Lk"};